const project = {
  slug: "propix-real-estate-chatbot",
  title: "Propix Real Estate Chatbot",
  oneLiner: "AI-powered chatbot for real estate lead qualification, scheduling, and FAQs.",
  role: ["AI/ML Developer", "Conversation Designer"],
  category: "AI/ML",
  clientOrOrg: "Propix AI (Subproject)",
  timeframe: { start: "2024-02", end: "2024-07", status: "Shipped" },
  domain: ["AI", "Chatbots", "Real Estate"],
  tech: ["LangFlow", "Python", "React widget", "Node.js", "GCP"],
  links: {
    live: "https://propixbot.hirun.lk/",
    flow: "https://miro.com/app/board/uXjVJP9EwdY=/?share_link_id=743433612160"
  },
  impact: [
    "Reduced manual agent workload by handling FAQs and initial queries.",
    "Captured and qualified leads faster with guided flows and scheduling."
  ],
  responsibilities: [
    "Designed conversation flow in Miro using LangFlow.",
    "Implemented intent handling and property Q&A logic.",
    "Integrated chatbot with Propix AI platform and WordPress."
  ],
  features: [
    "Buyer/Seller guided options",
    "Property Q&A (retrieval-based answers)",
    "Viewing calendar scheduling & agent handoff",
    "Admin dashboard for conversation tracking"
  ],
  architecture: [
    "LangFlow pipelines + Python services",
    "React widget embedded into site",
    "Node.js middleware → deployed on GCP"
  ],
  seo: {
    title: "Propix Real Estate Chatbot - Lead Qualification AI",
    description: "Developed a real-estate chatbot for property Q&A, lead qualification, and scheduling with LangFlow, Python, and GCP."
  },
  cover: "/assets/propix-realestate/realestatebot-featured.png"
};

export default project;
